import { Component, Input } from '@angular/core';

import { AccordionModule } from 'primeng/accordion';
import { Observable } from 'rxjs';
import { Collection } from '../../../graphql/generated/generated-types';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { SlugTypes } from '../../../routes/landing/components/product-categories/product-category-search-block/product-category-search-block.component';
import { AssetPreviewPipe } from '../../pipes/asset-preview.pipe';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';

@Component({
  selector: 'app-mobile-part-catalog-menu',
  standalone: true,
  imports: [CommonModule, AccordionModule, RouterLink, SkeletonModule, AssetPreviewPipe],
  templateUrl: './mobile-part-catalog-menu.component.html',
  styleUrl: './mobile-part-catalog-menu.component.scss'
})
export class MobilePartCatalogMenuComponent {
  @Input() collection$!: Observable<Collection | undefined>;
  @Input() collections!: Collection[];
  @Input() collectionsLoading: boolean;
  @Input() shop: boolean = false;

  constructor(public vehicleTypeService: VehicleTypeService,public selectedModificationService: SelectedModificationService){}

  public SlugTypes = SlugTypes;

  public getCollectionIsSlug(collection: Collection){
    const isSlugTranslation = collection?.translations?.find(
      (item) => item.languageCode === 'is'
    );
  
    if (isSlugTranslation) {
      return isSlugTranslation.slug
    } else {
      return collection.slug
    }   
}
}
